const WebHooksHome = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/WebHooksHome')
const CadastroWebHooks = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/CadastroWebHooks')
const AtualizarWebHook = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/AtualizarWebHook')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'webhooks',
    component: WebHooksHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Webhooks',
  },
  {
    path: 'webhooks/criar',
    component: CadastroWebHooks,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Webhooks/criar',
  },
  {
    path: 'webhooks/atualizar/:_id',
    component: AtualizarWebHook,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Webhooks/atualizar',
    props: true,
  },
]
